import preflightApiRequest from 'src/api/preflightApiRequest';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';

import {
  EMBROIDERY_PALETTE_ENDPOINT,
  EmbroideryPaletteItem,
  ColorPickerConfig,
} from './embroideryConfig';

let cachedConfig: ColorPickerConfig | null = null;

const getPreflightCdnUrl = (): string => {
  const { preFlightApiBaseUrl } = useIntegrationLayer();
  return preFlightApiBaseUrl.replace('://preflight.', '://preflight-cdn.');
};

const fetchEmbroideryPalette = async (): Promise<ColorPickerConfig> => {
  if (cachedConfig) return cachedConfig;

  const fullUrl = `${getPreflightCdnUrl()}${EMBROIDERY_PALETTE_ENDPOINT}`;
  const items = await preflightApiRequest(fullUrl, {}, 'data', 'GET') as EmbroideryPaletteItem[];

  cachedConfig = {
    enableOpacity: false,
    allowedColors: items.map((item) => item.hex),
    colorsInfo: items.reduce((acc, { hex, name, madeira_ref }) => ({
      ...acc,
      [hex]: { name, madeira_ref },
    }), {}),
  };

  return cachedConfig;
};

export default fetchEmbroideryPalette;
